import { SKILL_MATRIX_SECTIONS } from "./skillMatrixSections.mjs";

export const hrRedirect = (name) => (to) => ({ name, params: to.params, query: to.query, hash: to.hash });
export const HR_ROUTE_REDIRECTS = [
    ["/hr/mansioni/", "hr-mansioni"],
    ["/hr/mansioni/:id/", "hr-mansione-dettaglio"],
    ["/hr/attivita/:id/", "hr-attivita-dettaglio"],
    ["/hr/ruoli/", "hr-mansioni"],
    ["/hr/colloqui/nuovo/", "hr-colloquio-nuovo"],
    ["/hr/colloqui/:id/", "hr-colloquio"],
    ["/hr/colloqui/", "hr-colloqui"],
    ["/hr/sviluppo/colloqui/nuovo/", "hr-colloquio-nuovo"],
    ["/hr/sviluppo/colloqui/:id/", "hr-colloquio"],
    ["/hr/sviluppo/", "hr-colloqui"],
    ["/hr/centri-lavoro/operazioni-standard/:numero/", "hr-operazione-dettaglio"],
    ...SKILL_MATRIX_SECTIONS.map(section => [`/hr/centri-lavoro/${section.slug}/`, `hr-matrix-${section.slug}`]),
    ["/hr/skill-matrix", "hr-competenze"],
    ["/hr/skill-matrix/*", "hr-competenze"],
];
